import { reducer as form } from "redux-form";
import ajax from "./ajax";
import auth from "./auth";

export default {
  form,
  ajax,
  auth,
};
